import { render, staticRenderFns } from "./SdkPersonId.vue?vue&type=template&id=47d4fe97&"
import script from "./SdkPersonId.vue?vue&type=script&lang=js&"
export * from "./SdkPersonId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d4fe97')) {
      api.createRecord('47d4fe97', component.options)
    } else {
      api.reload('47d4fe97', component.options)
    }
    module.hot.accept("./SdkPersonId.vue?vue&type=template&id=47d4fe97&", function () {
      api.rerender('47d4fe97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/Metadata/SdkPersonId.vue"
export default component.exports